import {Injectable} from '@angular/core';
import {StoreKey} from "../../enums/local-store.enums";

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  constructor() {
  }

  getData<T = any>(key: StoreKey) {
    try {
      const data = localStorage.getItem(key);
      if (typeof data == 'object') {
        return JSON.parse(data ?? '') as T;
      } else {
        return data;
      }

    } catch {
      return null;
    }
  }

  saveData<T = any>(key: StoreKey, data: T) {
    try {
      if (typeof data === 'string') {
        localStorage.setItem(key, data);
      } else {
        localStorage.setItem(key, JSON.stringify(data));
      }
      return true;
    } catch (e) {
      console.error(e);
      return false;
    }
  }

  patchData<T extends object>(key: StoreKey, patch: Partial<T>): boolean {
    try {

      const existing: any = this.getData<T>(key);
      let updated: object;

      if (existing == null) {
        updated = {...patch} as T;
      } else {
        updated = this.deepMerge(JSON.parse(existing), patch);
      }
      return this.saveData(key, updated);
    } catch (e) {
      console.error(e);
      return false;
    }
  }

  private deepMerge(target: any, source: any): any {
    for (const key in source) {
      if (source.hasOwnProperty(key)) {
        if (this.isObject(source[key]) && this.isObject(target[key])) {
          this.deepMerge(target[key], source[key]);
        } else {
          target[key] = source[key];
        }
      }
    }
    return target;

   
  }
  
  isObject(item: any) {
      return item && typeof item === 'object' && !Array.isArray(item);
  }

  deleteData(key: StoreKey) {
    localStorage.removeItem(key);
  }

  clearStore() {
    localStorage.clear();
  }
}
